export default {
  container: 'pb-[28px] mt-[80px]',
  buttons: 'flex flex-row justify-center items-start gap-[12px] flex-1',
  contentWrapper: 'flex flex-col lg:flex-row',
  partnersWrapper: 'flex-1 py-[37px] border-t-[1px] border-color-border',
  partnerTitle: 'uppercase font-interSemibold text-[#0A52A1] text-[24px] leading-[29px] mb-[12px]',
  partnersImgWrapper: 'flex flex-col flex-wrap sm:flex-row gap-[34px] sm:gap-[50px] lg:gap-x-[130px] items-center justify-between',
  partnerImage: 'max-h-[80px]',
  undpImage: 'max-h-[100px]',
  text: 'font-inter text-color-lt-grey text-center text-[14px] leading-[20px]',
  textLink: 'hover:brightness-90',
  footerCred: 'flex justify-between pb-4 ms:pb-[50px] flex-col sm:flex-row',
  legalLink: 'flex gap-4 justify-center sm:justify-normal mt-4 sm:mt-0',
};
